// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3HTZ4","value":"Status_value__D2nHN"};